import { useEffect, useState } from 'react'

import { useAppDispatch } from '~/redux/hooks'

import { useGetMappingQuizPrerequisiteTasksQuery } from '../apis/mapping-quiz.api'
import { CurriculumTopicDataType } from '../types/curriculum.types'
import { CurriculumMappingQuizTask } from '../types/mapping-quiz.types'

const useMappingQuizPrerequisites = ({
  countryCode,
  gradeLevel,
  subject,
}: {
  countryCode: string
  gradeLevel: string
  subject: CurriculumTopicDataType
}): {
  isLoading: boolean
  isQuizComplete: boolean
  isQuizExist: boolean
  tasks: CurriculumMappingQuizTask[] | undefined
  totalPrerequisites: number | null
} => {
  const dispatch = useAppDispatch()
  const [prerequisitesCount, setPrerequisitesCount] = useState<number | null>(null)

  const {
    data: mappingQuizPrerequisiteTask,
    isLoading,
    isFetching,
    isError,
    isSuccess,
  } = useGetMappingQuizPrerequisiteTasksQuery(
    {
      countryCode,
      gradeLevel,
      subjectOrder: subject?.subjectOrder,
    },
    { skip: !subject?.subjectOrder },
  )

  function countNumberOfTasks(tasks: CurriculumMappingQuizTask[]): { totalTaskCount: number } {
    return tasks.reduce(
      (acc, task) => ({
        totalTaskCount: acc.totalTaskCount + task.subjectList?.length,
      }),
      { totalTaskCount: 0 },
    )
  }

  useEffect(() => {
    if (mappingQuizPrerequisiteTask?.tasks?.length) {
      const { totalTaskCount } = countNumberOfTasks(mappingQuizPrerequisiteTask?.tasks)
      setPrerequisitesCount(totalTaskCount)
    }
  }, [mappingQuizPrerequisiteTask, prerequisitesCount, dispatch, isLoading, isFetching, isError, isSuccess])

  return {
    isLoading: isLoading || isFetching,
    isQuizComplete: mappingQuizPrerequisiteTask?.isQuizComplete || false,
    isQuizExist: mappingQuizPrerequisiteTask?.isQuizExist || false,
    tasks: mappingQuizPrerequisiteTask?.tasks,
    totalPrerequisites: prerequisitesCount,
  }
}

export default useMappingQuizPrerequisites
